import React from 'react';
import PropTypes from 'prop-types';
import CallDetails from 'records/CallDetails';
import UserAvatar from 'components/pure/utils/UserAvatar';
import './PlaylistCall.styl';
import PlaylistCallTodo from 'components/coaching/PlaylistCallTodo';
import {browserHistory} from 'react-router';
import CoachingTodo from 'records/CoachingTodo';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import ArrowButton from 'components/pure/utils/ArrowButton';
import CoachingParticipant from 'records/CoachingParticipant';
import User from 'records/User';
import {ReactComponent as Delete} from 'images/playlist/smallX.svg';
import CoachingReview from 'records/CoachingReview';
import {navToLiveCoachingCall} from 'components/coaching/CallLink';

export default class PlaylistCall extends React.PureComponent {
  render() {
    const {
      call,
      caller,
      index,
      todo,
      otherTodo,
      active,
      participant,
      otherParticipant,
      onDelete,
      reviewId,
    } = this.props;

    const callOnClick = call.isMetadataOnly()
      ? () => navToLiveCoachingCall(call, reviewId)
      : () => browserHistory.push(`/call/${call.id}`);
    return (
      <div onClick={callOnClick} className="playlist-call">
        <div className="call-section">
          <div className={`call-number ${active ? 'orange-waves' : 'blue-waves'}`}>
            <span>Call {index + 1}:</span>
          </div>
          <div className="call-info">
            <UserAvatar user={caller} />
            <GenericTooltip tooltip={<span>{call.description}</span>}>
              <span
                // This style needs to be applied here to avoid being lost in
                // styl transpilation
                // https://github.com/postcss/autoprefixer/issues/1141
                style={{WebkitBoxOrient: 'vertical'}}
                className="call-name">
                {call.description}
              </span>
            </GenericTooltip>
            <div
              onClick={e => {
                e.stopPropagation();
                onDelete();
              }}
              className="icon-wrapper">
              <Delete />
            </div>
          </div>
        </div>
        <div className="todo-section">
          <PlaylistCallTodo
            participant={participant}
            otherParticipant={otherParticipant}
            call={call}
            todo={todo}
            otherTodo={otherTodo}
          />
          <div className="arrow-button-wrapper">
            <ArrowButton />
          </div>
        </div>
      </div>
    );
  }
}

PlaylistCall.propTypes = {
  review: PropTypes.instanceOf(CoachingReview),
  todo: PropTypes.instanceOf(CoachingTodo),
  otherTodo: PropTypes.instanceOf(CoachingTodo),
  call: PropTypes.instanceOf(CallDetails),
  index: PropTypes.number,
  active: PropTypes.bool,
  participant: PropTypes.instanceOf(CoachingParticipant),
  caller: PropTypes.instanceOf(User),
  otherParticipant: PropTypes.instanceOf(CoachingParticipant),
};
